export default __webpack_public_path__ + "static/media/logo-behance.1d8ee39f.svg";